import { Box, IconButton } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { red } from "@mui/material/colors";

const statusLabels = {
  not_start: "未動工",
  started: "施工中",
  finished: "完工",
  delivered: "已交付",
};

export function SitesTable({ rows, loading, role, userId, onEdit, onDelete }) {
  const columns = [
    { field: "job_code", headerName: "Job Code", width: 100 },
    { field: "name", headerName: "地盤名稱", width: 160 },
    { field: "contractor", headerName: "大判名稱", width: 120 },
    { field: "company_name", headerName: "KMK子公司", width: 120 },
    { field: "address", headerName: "地址", width: 220 },
    {
      field: "inventory_product_names",
      headerName: "貨物名稱",
      width: 250,
      renderCell: (params) => {
        const items = params.row.inventory_summary || [];
        return (
          <div style={{ whiteSpace: "normal" }}>
            {items.map(
              (i, idx) =>
                i.amount !== 0 &&
                i.product_name && <div key={idx}>{i.product_catalog_name}, {i.product_name}</div>
            )}
          </div>
        );
      },
    },
    {
      field: "inventory_product_amounts",
      headerName: "貨物數量",
      width: 120,
      renderCell: (params) => {
        const items = params.row.inventory_summary || [];
        return (
          <div style={{ whiteSpace: "normal" }}>
            {items.map(
              (i, idx) =>
                i.amount !== 0 &&
                i.product_name && <div key={idx}>{i.amount}</div>
            )}
          </div>
        );
      },
    },
    {
      field: "site_status",
      headerName: "施工狀態",
      width: 140,
      renderCell: (params) => statusLabels[params.value] || params.value,
    },
    { field: "remark", headerName: "備註", width: 200 },
    { field: "created_at", headerName: "新增時間", width: 140 },
    { field: "updated_at", headerName: "最後修改時間", width: 160 },
    {
      field: "actions",
      headerName: "動作",
      width: 120,
      renderCell: (params) => (
        <>
          <IconButton onClick={() => onEdit(params.row)}>
            <EditIcon />
          </IconButton>
          {userId && Number(userId) <= 3 && (
            <IconButton
              onClick={() => onDelete(params.row.id)}
              sx={{ color: red[800] }}
            >
              <DeleteIcon />
            </IconButton>
          )}
        </>
      ),
    },
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", p: 1 }}>
      <DataGrid
        rows={rows}
        columns={columns}
        loading={loading}
        pageSize={10}
        rowsPerPageOptions={[10]}
        getRowHeight={() => "auto"}
        disableRowSelectionOnClick
        disableColumnMenu={true}
      />
    </Box>
  );
}
